import React, { useState } from 'react';

import { trackCategoriesClicksAction } from 'analytics/categoriesWidget/trackCategoriesClicks';
import { WidgetWrapper, ImageWrapper, Image, CategoryName, WidgetTitle, Category } from './styles';
import CategoriesSlider from './CategoriesSlider/CategoriesSlider';
import { PureTranslator } from '../../../../../modules/translator';

const CATEGORIES_IMAGE_URL = `https://res.cloudinary.com/grover/image/upload/v1651234513/categories-widget`;
const CATEGORIES_IMAGE_URL_FALLBACK = `${CATEGORIES_IMAGE_URL}/computers.png`;

export const trackCategoriesClicks = (category, position) => {
    trackCategoriesClicksAction({
        destination_url: category.permalink,
        category_name: category.name,
        position,
    });
};

const CategoryContent = ({ title, imageUrl }) => {
    const [src, setSrc] = useState(imageUrl);

    return (
        <>
            <ImageWrapper>
                <Image
                    alt={title}
                    src={src}
                    onError={() => setSrc(`${CATEGORIES_IMAGE_URL_FALLBACK}`)}
                />
            </ImageWrapper>
            <CategoryName>{title}</CategoryName>
        </>
    );
};

export const CategoriesWidgetSlider = ({ categories, isMobileUser }) => {
    const imageUrlPrefix = `${CATEGORIES_IMAGE_URL}${isMobileUser ? '/mobile' : ''}`;

    return (
        <WidgetWrapper data-testid="categories-carousel">
            <WidgetTitle>
                <PureTranslator tk="CATEGORIES_WIDGET_HEADLINE" />
            </WidgetTitle>
            <CategoriesSlider isMobile={isMobileUser}>
                {categories?.map((category, idx) => (
                    <Category
                        to={category.permalink}
                        key={category.name}
                        onClick={() => trackCategoriesClicks(category, idx)}
                    >
                        <CategoryContent
                            title={category.name ?? ''}
                            imageUrl={`${imageUrlPrefix}/${category.permalink}.png`}
                        />
                    </Category>
                ))}
            </CategoriesSlider>
        </WidgetWrapper>
    );
};
